import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import style from "./Reservas.module.css";

export default function Reservas() {
  const navigate = useNavigate();
  const iframeRef = useRef(null);

  useEffect(() => {
    const metaViewport = document.createElement('meta');
    metaViewport.name = 'viewport';
    metaViewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
    document.head.appendChild(metaViewport);

    const script = document.createElement('script');
    script.src = 'https://www.covermanager.com/js/iframeResizer.min.js';
    script.type = 'text/javascript';
    script.async = true;
    
    script.onload = () => {
      if (typeof window.iFrameResize === 'function') {
        try {
          setTimeout(() => {
            window.iFrameResize({
              log: false,
              heightCalculationMethod: 'lowestElement',
              checkOrigin: false,
              resizeFrom: 'child',
              scrolling: true
            }, '#restaaurante-la-romana-de-betera');
          }, 1000);
        } catch (e) {
          console.error("Error al inicializar iFrameResize:", e);
        }
      } else {
        console.warn("La función iFrameResize no está disponible");
      }
    };
    
    document.head.appendChild(script);
    
    if (iframeRef.current) {
      iframeRef.current.style.touchAction = 'auto';
      iframeRef.current.style.webkitOverflowScrolling = 'touch';
    }
    
    return () => {
      if (document.head.contains(metaViewport)) {
        document.head.removeChild(metaViewport);
      }
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  const handleIframeTouchStart = () => {
    if (iframeRef.current) {
      try {
        iframeRef.current.focus();
      } catch (e) {
        console.error("Error en touchstart:", e);
      }
    }
  };

  const handleCall = () => {
    window.location.href = `tel:621288188`;
  };

  return (
    <div className={style.reservas_container}>
      <div className={style.header}>
        <h1>Reservar mesa</h1>
        <button 
          className={style.boton_volver}
          onClick={() => navigate(-1)}
        >
          Volver
        </button>
      </div>
      
      <div 
        className={style.iframe_wrapper}
        onTouchStart={handleIframeTouchStart}
      >
        <iframe
          ref={iframeRef}
          id="restaaurante-la-romana-de-betera" 
          title="Reservas"
          src="https://www.covermanager.com/reservation/module_restaurant/restaaurante-la-romana-de-betera/spanish"
          frameBorder="0" 
          height="700" 
          width="100%" 
          scrolling="yes"
          allowFullScreen
          allow="fullscreen"
        />
      </div>

      <button 
        className={style.boton_llamada_flotante}
        onClick={handleCall}
        aria-label="Llamar al 621288188"
      >
        📞
      </button>
    </div>
  );
}